import { createElement, forwardRef } from 'react'

import { splitProps } from '../helpers.mjs';
import { getCommonScrollbarStyle } from '../patterns/common-scrollbar.mjs';
import { styled } from './factory.mjs';

export const CommonScrollbar = /* @__PURE__ */ forwardRef(function CommonScrollbar(props, ref) {
  const [patternProps, restProps] = splitProps(props, ["horizontalScroll"])

const styleProps = getCommonScrollbarStyle(patternProps)
const mergedProps = { ref, ...styleProps, ...restProps }

return createElement(styled.div, mergedProps)
  })